import { type ReactNode } from 'react'
import { PanelHeader } from './PanelHeader'
import { TabBar } from '../../../../components/ChatPanel/TabBar'
import type { ChatTab } from '../../../../hooks/useTabManager'
import type { PanelState, PanelActions } from '../../types/PanelTypes'
import { useAgentAvatars } from '../../hooks/useAgentAvatars'

interface PanelLayoutProps {
    state: PanelState
    actions: PanelActions
    children: ReactNode

    // Tab-specific props (optional)
    tabManager?: {
        tabs: ChatTab[]
        activeTabId: string | null
    }

    // Drag & Drop handlers
    dragHandlers?: {
        onDragEnter: (e: React.DragEvent) => void
        onDragOver: (e: React.DragEvent) => void
        onDragLeave: (e: React.DragEvent) => void
        onDrop: (e: React.DragEvent) => void
    }

    // Refs for specific elements
    refs?: {
        searchButton?: React.RefObject<HTMLButtonElement | null>
        newTabButton?: React.RefObject<HTMLButtonElement | null>
    }
}

export const PanelLayout: React.FC<PanelLayoutProps> = ({
    state,
    actions,
    children,
    tabManager,
    dragHandlers,
    refs
}) => {
    const { isFullscreen, isDragging, showTabs } = state
    const agentAvatars = useAgentAvatars(tabManager?.tabs || [], [])

    return (
        <div
            className={`chat-panel-master h-full flex flex-col bg-white dark:bg-black ${isDragging ? 'ring-2 ring-blue-500 ring-inset' : ''
                }`}
            {...dragHandlers}
        >
            {/* Tab Bar (Conditional) */}
            {showTabs && tabManager && tabManager.tabs.length > 0 && (
                <div className={`w-full ${isFullscreen ? 'max-w-4xl mx-auto' : ''}`}>
                    <TabBar
                        tabs={tabManager.tabs}
                        activeTabId={tabManager.activeTabId || ''}
                        agentAvatars={agentAvatars || {}}
                        onTabClick={actions.onTabClick}
                        onTabClose={actions.onTabClose}
                        onAddTab={actions.openAgentSearch}
                        newTabButtonRef={refs?.newTabButton}
                    />
                </div>
            )}

            {/* Header */}
            <PanelHeader state={state} actions={actions} refs={refs} />

            {/* Content Area */}
            {children}
        </div>
    )
}
